/**
 * Created by Christal on 2018/5/14.
 */
export default {
  changeToken (state, token) {
    state.token = token
    try {
      localStorage.token = token
    } catch (e) {}
  },
  changeUsername (state, username) {
    state.username = username
    try {
      localStorage.username = username
    } catch (e) {}
  },
  changePassword (state, password) {
    state.password = password
    try {
      localStorage.password = password
    } catch (e) {}
  },
  changeRole (state, role) {
    state.role = role
    try {
      localStorage.role = role
    } catch (e) {}
  },
  changeEmployer (state, employer) {
    state.employer = employer
    try {
      localStorage.employer = employer
    } catch (e) {}
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js